export default __webpack_public_path__ + "static/media/navigation.3d83620b.svg";